import React, { FunctionComponent, ReactNode } from 'react';

import styled, { css, keyframes } from 'styled-components';

import { colors } from 'chime-ui/system';

export type InputType = {
  hasError?: boolean;
  endAdornment?: ReactNode;
};

type InputProps = InputType & React.HTMLProps<HTMLInputElement>;

const ForwardedInput: FunctionComponent<InputProps> = React.forwardRef(
  function Input({ endAdornment, hasError, ...props }, ref) {
    return (
      <InputContainer hasError={hasError}>
        <StyledInput ref={ref} {...props} />
        {endAdornment}
      </InputContainer>
    );
  }
);

export default ForwardedInput;

export const onAutoFillStart = keyframes`
  from {}
`;

export const onAutoFillCancel = keyframes`
  to{}
`;

const StyledInput = styled.input`
  width: 100%;
  min-width: 0;
  font-weight: 400;
  font-family: inherit;
  color: inherit;
  outline: none;
  appearance: none;
  background-color: transparent;
  border: none;
  position: relative;
  line-height: 1.375rem;
  margin: 1.5rem 0.5rem 0.5rem;
  /** this normalizes between safari and others */
  padding: 1px 2px;

  &:focus {
    &::placeholder {
      color: inherit;
      opacity: 1;
    }
  }

  &::placeholder {
    opacity: 0;
  }

  &:-ms-input-placeholder {
    opacity: 1;
    color: transparent;
  }

  &::-ms-clear {
    display: none;
  }

  &:-webkit-autofill {
    animation: ${onAutoFillStart};
  }

  &:not(:-webkit-autofill) {
    animation: ${onAutoFillCancel};
  }

  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    /** super hacky css to get rid of the autofill background */
    transition: background-color 9999s ease-out;
  }
`;

export const InputContainer = styled.div`
  padding: 0px;
  background-color: transparent;
  border-radius: 0.5rem;
  display: flex;
  position: relative;
  border: solid 2px ${colors.lightGrey};
  border-radius: 0.5rem;
  height: 4rem;

  &:focus-within {
    border: solid 2px ${colors.brightGreen};
    &::placeholder {
      color: inherit;
      opacity: 1;
    }
  }

  ${props =>
    props.hasError &&
    css`
      background-color: ${colors.tint.alertRed.a10};
      border: solid 2px ${colors.alertRed};

      &:focus-within {
        background-color: transparent;
      }
    `};
`;
